// extracted by mini-css-extract-plugin
module.exports = {"content":"Description_content__1uwxg","columns":"Description_columns__3lUCW","submitBtn":"Description_submitBtn__3EZj3"};